const plans = [
  {
    name: 'Basico',
    price: '$289',
    day: 'Menos de $10 al dia',
    people: 'Titular + 2 familiares registrados',
    included: ['Titular + 2 familiares registrados', 'Coordinacion con funerarias aliadas', 'App de gestion de membresia', 'Sin contratos forzosos'],
    recommended: false,
  },
  {
    name: 'Prime',
    price: '$399',
    day: 'Desde $13.30 al dia',
    people: 'Titular + 3 familiares registrados',
    included: ['Titular + 3 familiares registrados', 'Todo lo del plan Basico', 'Mayor capacidad familiar', 'Mas espacios de registro familiar'],
    recommended: true,
  },
];

export default function Coverage() {
  const goToCta = () => {
    const el = document.getElementById('cta-final');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="planes" className="bg-[#F7F6FF] py-14 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex rounded-full border border-[#DDD8F5] bg-white px-4 py-2 text-xs font-black uppercase tracking-wide text-[#534AB7]">
            Planes
          </span>
          <h2 className="mt-5 font-title text-3xl font-black leading-tight tracking-[-0.035em] text-[#171421] md:text-5xl">
            Elige el plan que mejor se adapta a tu familia
          </h2>
          <p className="mt-5 text-base leading-8 text-[#625D70] md:text-lg">
            Ambos planes incluyen una membresia digital, familiares registrados y coordinacion con funerarias aliadas de prestigio.
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-2">
          {plans.map((plan) => (
            <article
              key={plan.name}
              className={`relative rounded-[32px] border bg-white p-6 shadow-xl shadow-[#3C3489]/8 md:p-8 ${
                plan.recommended ? 'border-[#534AB7]' : 'border-[#E8E4F8]'
              }`}
            >
              {plan.recommended && (
                <span className="absolute right-5 top-5 rounded-full bg-[#534AB7] px-4 py-1.5 text-xs font-black text-white">
                  Recomendado
                </span>
              )}
              <h3 className="text-2xl font-black text-[#171421]">{plan.name}</h3>
              <div className="mt-5 flex items-end gap-2">
                <p className="text-5xl font-black tracking-tight text-[#534AB7]">{plan.price}</p>
                <p className="pb-2 text-sm font-bold text-[#716B80]">/mes</p>
              </div>
              <p className="mt-2 text-sm font-bold text-[#716B80]">{plan.day}</p>
              <div className="mt-6 rounded-3xl bg-[#F7F6FF] p-4">
                <p className="text-lg font-black text-[#242033]">{plan.people}</p>
              </div>
              <ul className="mt-6 space-y-3">
                {plan.included.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm font-semibold text-[#565166]">
                    <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#E9E5FF] text-[#534AB7]">
                      <i className="ri-check-line text-xs" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <button
                onClick={goToCta}
                className={`mt-7 w-full rounded-2xl px-5 py-4 text-sm font-black transition-transform hover:scale-[1.01] ${
                  plan.recommended ? 'bg-[#534AB7] text-white' : 'bg-[#F1EEFF] text-[#534AB7]'
                }`}
              >
                Elegir {plan.name}
              </button>
              <p className="mt-4 text-center text-xs font-semibold text-[#8A8497]">
                Servicios sujetos a periodo de carencia y condiciones del plan.
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
